module.exports = __webpack_public_path__ + "static/media/picto-chevron-down-white.8cd751d6.svg";